interface ChartIconProps {
  className?: string;
  wrapperClassName?: string;
}

const ChartIcon = ({
  className = '',
  wrapperClassName = 'w-8 h-8 bg-primary-50 rounded-full flex items-center justify-center',
}: ChartIconProps) => (
  <div className={wrapperClassName}>
    <svg
      width='16'
      height='16'
      viewBox='0 0 24 24'
      fill='none'
      className={`text-primary-600 ${className}`}
    >
      <path
        d='M3 3v18h18M7 16l4-4 4 4 6-6'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='7' cy='16' r='1' fill='currentColor' />
      <circle cx='11' cy='12' r='1' fill='currentColor' />
      <circle cx='15' cy='16' r='1' fill='currentColor' />
      <circle cx='21' cy='10' r='1' fill='currentColor' />
    </svg>
  </div>
);

export default ChartIcon;
